// src/scenes/MultiplayerMenuScene.js - v2 - Uses BaseMenuScene structure & MenuUIUtils
import { checkIsAdmin } from "../services/profileService.js";
import MenuUIUtils from "../ui/MenuUIUtils.js";
import BaseMenuScene from "./BaseMenuScene.js";
import { auth } from "../firebaseConfig.js"; // Import auth for back button logic
import { hasSpecialAccess } from "../services/specialAccessService.js"; // Import for Guest+ support

class MultiplayerMenuScene extends BaseMenuScene {
  constructor() {
    super({ key: "MultiplayerMenuScene" });
    this.centered = true; // Center the menu items vertically
    // Use background options from BaseMenuScene - defaults to AI theme
  }

  async create() {
    super.create(); // Sets up background, resize listeners
    // Create Title using MenuUIUtils
     this.uiElements.title = MenuUIUtils.createTitle(this, "TEAM MODE", 80, {
         color: MenuUIUtils.COLORS.secondary, // Cyan title
         size: MenuUIUtils.FONTS.sizeXl // Slightly smaller title
     });
    // Create menu items (async operation due to isAdmin check)
    await this.createMenuItems();
     // Ensure initial positioning
     this.handleResize();

     
    // --- ENSURE THESE LINES ARE AT THE END ---
   
   console.log(`[${this.scene.key}] create method finished.`);

  }

  async createMenuItems() {
    this.clearMenuItems(); // Clear existing items array
    // Define start Y position and spacing
    this.baseY = this.cameras.main.height * 0.35;
    const itemSpacing = this.calculateIdealSpacing(); // Use calculated spacing
    const targetX = this.cameras.main.width / 2; // Always centered
    let currentY = this.baseY;
    // --- Create Game ---
    this.createMenuItem(targetX, currentY, "CREATE GAME",
         () => sceneManager.switchToScene("CreateGameScene"),
         { size: MenuUIUtils.FONTS.sizeLg }
    );
    currentY += itemSpacing;
    // --- Join Game ---
    this.createMenuItem(targetX, currentY, "JOIN GAME",
         () => sceneManager.switchToScene("JoinGameScene"),
         { size: MenuUIUtils.FONTS.sizeLg }
    );
    currentY += itemSpacing;
    // --- Admin Console (Conditional) ---
    try {
         const user = auth.currentUser;
         const isAdmin = user ? await checkIsAdmin(user.uid) : false;
         if (isAdmin) {
             this.createMenuItem(targetX, currentY, "ADMIN CONSOLE",
                  () => sceneManager.switchToScene("AdminConsoleScene"),
                  { fill: MenuUIUtils.COLORS.accent3, size: MenuUIUtils.FONTS.sizeLg } // Purple
              );
             currentY += itemSpacing;
         }
    } catch (error) { console.error("Error checking admin status:", error); }
    // --- Back Button ---
     const user = auth.currentUser;
     const specialAccess = hasSpecialAccess();
     const isVerifiedUser = user && user.emailVerified;
     const isEffectivelyLoggedIn = isVerifiedUser || specialAccess;
     
     // CRITICAL FIX: Use feature flag routing instead of hard-coded scene names
     const useUniversalLanding = localStorage.getItem('pptHeroUseUniversalLanding') === 'true';
     const useDOMMenus = localStorage.getItem('pptHeroUseDOMMenus') === 'true';
     const useDOMAuthMenu = localStorage.getItem('pptHeroUseDOMAuthMenu') === 'true';
     
     let backTargetScene;
     if (useUniversalLanding) {
         backTargetScene = 'MainMenuSceneUniversal';
     } else if (isEffectivelyLoggedIn) {
         backTargetScene = useDOMAuthMenu ? "AuthenticatedMenuSceneDOM" : "AuthenticatedMenuScene";
     } else {
         backTargetScene = useDOMMenus ? "GuestMenuSceneDOM" : "GuestMenuScene";
     }
    this.createMenuItem(targetX, currentY, "BACK",
         () => sceneManager.switchToScene(backTargetScene),
         { fill: MenuUIUtils.COLORS.textDark, size: MenuUIUtils.FONTS.sizeLg } // Grey text
    );
     // Reposition items after creation (in case spacing changed)
     this.handleResize();
  }
  // handleResize is inherited from BaseMenuScene and works correctly for centered items
}

export default MultiplayerMenuScene;